// Catalog.ID Client — the agreement a Terms step asks a member to accept
// ============================================================================
// A link to the very PDF the kit appends at print time, so what is read here
// is what is printed later (staging test 2026-10-15: the agreement appeared only
// in the printed set, after it had been accepted). A new tab: the wizard is
// mid-flight, and in the dashboard it is iframed.

import { createElement } from '@catalog-shell';
import type { TermsAsset } from './terms-asset';

export function createAgreementLink(asset: TermsAsset): HTMLElement {
    const row = createElement('div', { className: 'cid-auth-link-row' });
    const link = createElement('a', {
        className: 'cid-auth-link',
        textContent: `Read the ${asset.title} (PDF, ${asset.pages} pages)`,
    });
    link.setAttribute('href', asset.url);
    link.target = '_blank';
    link.rel = 'noopener';
    row.appendChild(link);
    return row;
}
